/** Normalizes string paths, Next.js StaticImageData, and default SVG module exports. */
export function normalizeSvgSrc(src: unknown): string {
  if (typeof src === "string") return src;
  if (!src || typeof src !== "object") return "";

  if ("src" in src && typeof (src as { src: unknown }).src === "string") {
    return (src as { src: string }).src;
  }

  if ("default" in src) {
    return normalizeSvgSrc((src as { default: unknown }).default);
  }

  return "";
}
